<template>
      <v-card class="mx-auto" shaped elevation="7" min-height="700px">
            <v-card-title>
                  Informe Liquidación Prima
                  <ModalInformeLiquidacionComponent :open="obModal.openModal" :obModal="obModal" :parametros="parametros" :listGeneral="listGeneral"/>
            </v-card-title>
            <v-card-text>
                  <v-container fluid grid-list-md>
                        <v-form ref="form">
                              <v-row dense>
                                    <v-col cols="12" sm="4" v-if="_.get(parametros,'is_aseguradora',false)">
                                          <v-text-field label="Aseguradora" color="textbox"
                                                :value="_.get(listGeneral,['listAseguradora','0','aseguradora'],'N/A')"
                                                outlined dense readonly />
                                    </v-col>
                                    <v-col cols="12" sm="4" v-else>
                                          <v-autocomplete label="Aseguradora *" color="textbox"
                                                v-model="obSearch.idAseguradora" :items="listGeneral.listAseguradora"
                                                item-text="aseguradora" item-value="idAseguradora" outlined dense
                                                @change="onListarSeguro" :rules="requeridoRegla" />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-autocomplete label="Seguro *" color="textbox" v-model="obSearch.idSeguro"
                                                :items="listGeneral.listSeguro" item-text="seguro" item-value="idSeguro"
                                                outlined dense @change="onListarProducto" :rules="requeridoRegla" />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-autocomplete label="Producto *" color="textbox"
                                                v-model="obSearch.idProducto" :items="listGeneral.listProducto"
                                                outlined dense :rules="requeridoRegla" />
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="4">
                                          <v-dialog ref="dialogFechaDesde" v-model="objDate.desde.abrirModal"
                                                :return-value.sync="obSearch.fechaInicioCorte" persistent width="340px">
                                                <template v-slot:activator="{ on }">
                                                      <v-text-field color="textbox" v-model="obSearch.fechaInicioCorte"
                                                            label="Fecha Desde *" prepend-inner-icon="event" readonly
                                                            outlined dense v-on="on" :rules="requeridoRegla" />
                                                </template>
                                                <v-date-picker color="primary" v-model="obSearch.fechaInicioCorte"
                                                      scrollable locale="es">
                                                      <v-spacer></v-spacer>
                                                      <v-btn outlined dense rounded color="danger"
                                                            @click="objDate.desde.abrirModal = false" v-html="'Salir'">
                                                      </v-btn>
                                                      <v-btn rounded dark color="primary"
                                                            @click="$refs.dialogFechaDesde.save(obSearch.fechaInicioCorte);"
                                                            v-html="'Guardar Fecha'"></v-btn>
                                                </v-date-picker>
                                          </v-dialog>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-dialog ref="dialogFechaHasta" v-model="objDate.hasta.abrirModal"
                                                :return-value.sync="obSearch.fechaFinCorte" persistent width="340px">
                                                <template v-slot:activator="{ on }">
                                                      <v-text-field color="textbox" v-model="obSearch.fechaFinCorte"
                                                            label="Fecha Hasta *" prepend-inner-icon="event" readonly
                                                            outlined dense v-on="on" :rules="requeridoRegla" />
                                                </template>
                                                <v-date-picker color="primary" v-model="obSearch.fechaFinCorte"
                                                      scrollable locale="es">
                                                      <v-spacer></v-spacer>
                                                      <v-btn outlined dense rounded color="danger"
                                                            @click="objDate.hasta.abrirModal = false" v-html="'Salir'">
                                                      </v-btn>
                                                      <v-btn rounded dark color="primary"
                                                            @click="$refs.dialogFechaHasta.save(obSearch.fechaFinCorte);"
                                                            v-html="'Guardar Fecha'"></v-btn>
                                                </v-date-picker>
                                          </v-dialog>
                                    </v-col>
                                    <v-col cols="12" sm="4" class="text-right">
                                          <v-tooltip top color="primary">
                                                <template v-slot:activator="{ on }">
                                                      <v-btn fab dark small color="primary" @click="onListar" v-on="on"
                                                            :disabled="disabled">
                                                            <v-icon dark>search</v-icon>
                                                      </v-btn>
                                                </template>
                                                <span>Buscar</span>
                                          </v-tooltip>
                                    </v-col>
                              </v-row>
                        </v-form>

                        <v-row dense>
                              <v-col v-if="_.size(listGeneral.detalle) == 0" cols="12" sm="6"/>
                              <v-col v-else cols="12" sm="6">
                                    <v-btn rounded color="primary" dark @click="exportar('tableInfPri','Informe de Liquidación Prima')">Exportar a XLSX</v-btn>
                              </v-col>
                              <v-col cols="12" sm="6">
                                    <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable
                                          dense prepend-inner-icon="search" />
                              </v-col>
                        </v-row>
                        <v-row dense>
                              <v-col cols="12">
                                    <v-data-table :search="obSearch.search" id="tableInfPri"
                                          :headers="listGeneral.cabecera" :items="listGeneral.detalle"
                                          class="elevation-3">

                                          <template v-slot:body.append>
                                                <tr v-show="_.size(listGeneral.detalle) > 0">
                                                      <td colspan="6"></td>
                                                      <td>
                                                            <span class="font-weight-black"
                                                                  v-html="`$${Number.parseFloat(totalPrimaNeta).toFixed(4) }`"></span>
                                                      </td>
                                                      <td>
                                                            <span class="font-weight-black"
                                                                  v-html="`$${Number.parseFloat(totalImpuesto).toFixed(4) }`"></span>
                                                      </td>
                                                      <td>
                                                            <span class="font-weight-black"
                                                                  v-html="`$${Number.parseFloat(totalPrimaBruta).toFixed(4) }`"></span>
                                                      </td>
                                                      <td></td>
                                                </tr>
                                          </template>

                                          <template v-slot:item.name="{ item }">
                                                <v-btn class="ma-2" text icon color="primary" @click="ver(item)">
                                                      <v-icon small>visibility</v-icon>
                                                </v-btn>
                                          </template>

                                          <template v-slot:no-results>
                                                Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó
                                                resultados.
                                          </template>
                                    </v-data-table>
                              </v-col>
                        </v-row>

                        <v-row dense >
                            <v-col cols="12">
                                <modalPdfComponent :mostrar="objPdf.mostrar" :base64="objPdf.base64" :titulo="objPdf.titulo"/>
                            </v-col>
                        </v-row>
                  </v-container>
            </v-card-text>
      </v-card>
</template>

<script>
      export default {
            name: 'InformeLiquidacionView',
            components:{
                  ModalInformeLiquidacionComponent: () => import('@/components/liquidacion/ModalInformeLiquidacionComponent.vue'),
                  modalPdfComponent: () => import('@/components/utilites/modalComponent.vue')
            },
            data: () => ({
                  objDate: {
                        desde: {
                              abrirModal: false
                        },
                        hasta: {
                              abrirModal: false
                        },
                  },
                  obSearch: {
                        search: '',
                        fechaInicioCorte: moment().format('YYYY-MM-DD'),
                        fechaFinCorte: moment().format('YYYY-MM-DD'),
                        idAseguradora: null,
                        idSeguro: null,
                        idProducto: null
                  },
                  obModal:{
                        titulo:'Detalle de Informe de Liquidación',
                        openModal:false                        
                  },
                  objPdf:{
                        mostrar: false,
                        base64: '',
                        titulo: ''
                  },
                  listGeneral: {},
                  parametros: {},
                  disabled: false
            }),
            created() {
                  var error = 'E';

                  axios.post(`${BASE_URI}administrador/informe-liquidacion/cargaGeneral`)
                        .then((r) => {
                              if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                              if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                                    this.$set(this, 'listGeneral', r.data.data.listas);
                                    this.$set(this, 'parametros', r.data.data.parametros);
                                    if(this.parametros.is_aseguradora)
                                          this.obSearch.idAseguradora = this.listGeneral.listAseguradora[0].id_aseguradora;
                                    else
                                          this.obSearch.idAseguradora = this.listGeneral.listAseguradora[0].idAseguradora;
                              return this.onListarSeguro('L');
                        })
                        .catch((e) => {
                              mensajesAlerta(e, error);
                        })
            },
            computed: {
                  totalPrimaNeta() {
                        var l = _.cloneDeep(_.get(this.listGeneral,'detalle',[]));
                        return _.sumBy(l, (v) => {
                              return _.toNumber(v.totalPrimaNeta);
                        });
                  },
                  totalImpuesto() {
                        var l = _.cloneDeep(_.get(this.listGeneral,'detalle',[]));
                        return _.sumBy(l, (v) => {
                              return _.toNumber(v.totalImpuesto);
                        });
                  },
                  totalPrimaBruta() {
                        var l = _.cloneDeep(_.get(this.listGeneral,'detalle',[]));
                        return _.sumBy(l, (v) => {
                              return _.toNumber(v.totalPrimaBruta);
                        });
                  },
            },
            methods: {
                  onListarSeguro(ev) {
                        if (!_.isUndefined(ev)) {
                              var error = 'E';
                              var o = _.merge({
                                          opcion: 'L_SEGURO_X_ASEGURADORA',
                                          idTipoPoliza: this.parametros.id_tipo_poliza_maestra
                                    },
                                    _.pick(this.obSearch, 'idAseguradora')
                              );

                              this.listGeneral.listSeguro = [];
                              axios.post(`${BASE_URI}administrador/poliza/listar`, o)
                                    .then((r) => {
                                          if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                          if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                                                this.listGeneral.listSeguro = r.data.data;
                                    })
                                    .catch((e) => {
                                          mensajesAlerta(e, error);
                                    });
                        }
                  },
                  onListarProducto(ev) {
                        if (!_.isUndefined(ev)) {
                              var error = 'E';
                              var o = _.merge({
                                          opcion: 'LISTARCOMBO'
                                    },
                                    _.pick(this.obSearch, ['idAseguradora', 'idSeguro'])
                              );

                              this.listGeneral.listProducto = [];
                              axios.post(`${BASE_URI}administrador/producto/listar`, o)
                                    .then((r) => {
                                          if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                          if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                                                this.listGeneral.listProducto.push({text:'Todos',value:'0'});
                                                _.map(_.cloneDeep(r.data.data),(v)=>{
                                                      this.listGeneral.listProducto.push({
                                                            text:v.nombre_producto,
                                                            value:v.id_producto,
                                                      });
                                                });
                                    })
                                    .catch((e) => {
                                          mensajesAlerta(e, error);
                                    });
                        }
                  },
                  onListar(ev) {
                        if (!_.isUndefined(ev)) {
                              try {
                                    this.disabled = true;
                                    if (!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                                    var error = 'E';
                                    var o = _.merge({opcion: 'LISTAR',idProducto:_.toNumber(this.obSearch.idProducto) == 0 ? null : this.obSearch.idProducto},
                                          _.pick(this.obSearch, ['fechaInicioCorte','fechaFinCorte']),
                                    );

                                    this.listGeneral.detalle = [];
                                    axios.post(`${BASE_URI}administrador/informe-liquidacion/listar`, o)
                                          .then((r) => {
                                                if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                                if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion); }
                                                      var l = _.cloneDeep(r.data.data);
                                                      l = _.map(l,(v)=>{
                                                            v.totalPrimaNeta  = Number.parseFloat(v.totalPrimaNeta,4).toFixed(4);
                                                            v.totalImpuesto   = Number.parseFloat(v.totalImpuesto,4).toFixed(4);
                                                            v.totalPrimaBruta = Number.parseFloat(v.totalPrimaBruta,4).toFixed(4);
                                                            var s = _.split(v.path,'/');
                                                            v.documento = s[_.size(s)-1];
                                                            return v;
                                                      });
                                                      this.listGeneral.detalle = l;
                                                      this.disabled = false;
                                          })
                                          .catch((e) => {
                                                mensajesAlerta(e, error);
                                                this.disabled = false;
                                          });
                              } catch (ex) {
                                    mensajesAlerta(ex, 'I');
                                    this.disabled = false;
                              }
                        }
                  },
                  ver(v){
                        var error = 'E';
                        
                        axios.post(`${BASE_URI}administrador/repository-file/listar`,{'path': v.path})
                         .then((r) => {
                             if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                             if(_.size(_.get(r,['data','data'],[])) == 0) { error= 'I'; throw 'Error al leer el archivo PDF.'; } 
                                 this.objPdf.base64 = JSON.parse(JSON.stringify(r.data.data));
                                 this.objPdf.titulo = 'Informe de Liquidación Comisión';
                                 this.objPdf.mostrar = true;
                         })
                         .catch((e) => {
                             mensajesAlerta(e,error);
                         });
                  },
                  close(band){
                        this.obModal.openModal = band;
                  },
                  cerrarModalPdf(){
                        this.objPdf.mostrar =  false;
                        this.objPdf.base64 = '';
                  }
            },
            provide(){
                  return{
                        close:this.close,
                        cerrarModalPdf: this.cerrarModalPdf
                  }
            }
      }
</script>